// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"2ff8a3ff","826":"80771f83"}[chunkId] + ".chunk.css";
};